import { IMedia } from '../common/types';

const asyncIntervals: boolean[] = [];

const runAsyncInterval = async (cb: () => any, interval: number, intervalIndex: number): Promise<void> => {
  await cb();
  if (asyncIntervals[intervalIndex]) {
    setTimeout(() => runAsyncInterval(cb, interval, intervalIndex), interval);
  }
};

export const setAsyncInterval = (cb: any, interval: number): number => {
  if (cb && typeof cb === "function") {
    const intervalIndex = asyncIntervals.length;
    asyncIntervals.push(true);
    runAsyncInterval(cb, interval, intervalIndex);
    return intervalIndex;
  } else {
    throw new Error('Callback must be a function');
  }
};

export const clearAsyncInterval = (intervalIndex: number): void => {
  if (asyncIntervals[intervalIndex]) {
    asyncIntervals[intervalIndex] = false;
  }
};

/**
 * Server responses currently contain media item object with values typed wrong.
 * Until it is fixed in the backend, we need to normalize them here:
 * - `type` is of type string in responses, needs to be a number
 *
 * - @yguillemot
 * @param data IMedia
 * @returns IMedia
 */
export const normalizeMediaItem = (data: IMedia): IMedia => {
  return {
    ...data,
    type: parseInt(data.type as unknown as string, 10),
  }
}